// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__3AX3w","productName":"Table_productName__15O4W"};